export var now = function () {
    return Date.now ? Date.now() : +new Date();
};



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/moment/now.js
// module id = 1367
// module chunks = 3